import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import { addNewItem as onAddNewItem } from "store/products/actions"
import { editItem as onEditItem } from "store/products/actions"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import {showSuccessToast} from "helpers/function_helper"
import { getMasterCoaList } from "helpers/backend_helper"

const AddNewCOA = props => {
  const dispatch = useDispatch()


  const [validation, setValidation] = useState({
    accountName: null,
    groupName: null
  })
  const [groupName, setGroupName] = useState('')
  const [accountName, setAccountName] = useState('')
  const [accountCode, setAccountCode] = useState('')
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [showLoading, setShowLoading] = useState(false)
  const [dropDownLoading, setdropDownLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [coaGroupList, setCoaGroupList] = useState([])
 
  useEffect(() => {
    //console.log('details for edit:'+JSON.stringify(props.detailsForEdit))
    if(props.isEdit){
      setGroupName(props.detailsForEdit.groupId)
      setAccountCode(props.detailsForEdit.accountCode)
      setAccountName(props.detailsForEdit.accountName)
    }
  }, [props.detailsForEdit])

  useEffect(() => {
    getAllMasterCoas()
  }, [])

  const paddingStyles = {
    option: (styles, { data }) => {
        return {
            ...styles,
            paddingLeft : data.padding,
        };
    },
  };
  
  async function getAllMasterCoas(){
    setdropDownLoading(true)
    const resp = await getMasterCoaList({})
    let tempArray = []
    let selectedOption = null;
    resp.forEach(each => {
      if(each.parentGroupId){
        //tempArray.filter(x => x[each.id])
        const indx = tempArray.findIndex(x => x.value === each.parentGroupId)
        tempArray[indx].options.push({
          label: each.groupName,
          value : each.id,
          padding : 25
        })
      }
      else{
        let oneOption = {
          label: each.groupName,
          value : each.id,
          options : [],
          padding: 10
        }
        tempArray.push(oneOption)
      }
      if(props.isEdit && each.id == props.detailsForEdit.groupId){
        selectedOption = {
          label : each.groupName,
          value: each.id
        }
      }
      

    })
    let tempArray2 = []
    tempArray.forEach(each => {
      tempArray2.push({
        label: each.label,
        value : each.value,
        padding: 10
      })
      tempArray2.push({
        options:each.options,
      })
    })
    //console.log('aa:'+JSON.stringify(tempArray2))
    setCoaGroupList(tempArray2)
    if(selectedOption && selectedOption != null){
      setSelectedGroup(selectedOption)
    }
    setdropDownLoading(false)
  }

  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm(){
    setErrorMessage('')
    const modifiedV = { ...validation }
    let formValid = true;
    if(accountName && accountName != ""){
      modifiedV["accountName"] = true
    }
    else{
      modifiedV["accountName"] = false
      formValid = false
    }

    if(groupName && groupName != ""){
      modifiedV["groupName"] = true
    }
    else{
      modifiedV["groupName"] = false
      formValid = false
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    
    const formValid = validateForm();

    if(formValid){
      setShowLoading(true)

      const response = await onAddItemDirect({
        'accountName': accountName,
        'accountCode' : accountCode,
        'groupId' : groupName
      }, 'COA')

      setShowLoading(false)

      if(response.status == 'success'){
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    
    const formValid = validateForm();

    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
        'id': props.detailsForEdit.id,
        'accountName': accountName,
        'accountCode' : accountCode,
        'groupId' : groupName
      }, 'COA')

      setShowLoading(false)

      if(response.status == 'success'){
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }

      /*
      dispatch(onEditItem({
        'id': props.detailsForEdit.subCategoryId,
        'key' : categoryName,
        'value' : accountName
      }, 'SubCategory'))*/
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="productcode">
                              Account Name *
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="productcode"
                              maxLength="100"
                              value={accountName}
                              onChange={event => {
                                onChangeValidation("accountName", event.target.value.trim())
                                setAccountName(event.target.value)
                              }}
                              invalid={
                                validation["accountName"] !== true &&
                                validation["accountName"] !== null
                              }
                            />
                            {(validation["accountName"] === false) &&
                              <div className="custom-error">
                                Please enter a Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="accoutcode">
                              Account Code
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="accoutcode"
                              maxLength="100"
                              value={accountCode}
                              onChange={event => {
                                setAccountCode(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                            <Label for="groupid">
                              Group *
                            </Label>
                            <Select
                              value={selectedGroup}
                              onChange={(e) => {
                                setSelectedGroup(e)
                                onChangeValidation("groupName", e.value)
                                setGroupName(e.value)
                              }}
                              options={coaGroupList}
                              styles={paddingStyles}
                              classNamePrefix="select2-selection"
                              isLoading={dropDownLoading}
                              id="groupid"
                            />
                            {(validation["groupName"] === false) &&
                              <div className="custom-error">
                                Please select a Group
                              </div>
                            }
                          </div>
                          
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {(showLoading) && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                SAVE
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewCOA.propTypes = {
  newlyAddedValue: PropTypes.func,
  onGetCategoriesAndSubCategories: PropTypes.func,
  selectedId: PropTypes.any,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool
}

export default AddNewCOA
